import { useEffect, useState } from "react";
import api from "../../lib/api";

const Card = ({ label, value, accent = false, testid }) => (
  <div
    data-testid={testid}
    className={`border ${accent ? "border-[#1E3A8A] bg-[#1E3A8A] text-white" : "border-[#E5E0D8] bg-white text-[#111]"} p-5`}
  >
    <p className={`label-eyebrow ${accent ? "text-[#F4C430]" : "text-[#555]"}`}>— {label}</p>
    <p className="font-serif-display text-3xl mt-3 font-light tracking-tighter">{value}</p>
  </div>
);

const fmt$ = (n) =>
  typeof n === "number" ? `$${n.toLocaleString(undefined, { maximumFractionDigits: 0 })}` : "—";

export const AnalyticsCards = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api
      .get("/dashboard/analytics")
      .then(({ data }) => setData(data))
      .catch(() => setError(true));
  }, []);

  if (error) return null;
  if (!data) {
    return (
      <div data-testid="analytics-loading" className="mt-10 label-eyebrow text-[#555]">
        Loading analytics…
      </div>
    );
  }

  if (data.role === "artist") {
    return (
      <div data-testid="artist-analytics" className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4">
        <Card label="Revenue" value={fmt$(data.revenue_usd)} accent testid="stat-revenue" />
        <Card label="Sold" value={data.artworks_sold} testid="stat-sold" />
        <Card label="On view" value={data.artworks_live} testid="stat-live" />
        <Card label="Avg sale" value={fmt$(data.avg_sale_usd)} testid="stat-avg" />
        <Card label="Live auctions" value={data.live_auctions} testid="stat-auctions" />
        <Card label="Bids received" value={data.total_bids_received} testid="stat-bids" />
        <Card label="Total works" value={data.artworks_total} testid="stat-total" />
        <Card
          label="Sell-through"
          value={
            data.artworks_total
              ? `${Math.round((data.artworks_sold / data.artworks_total) * 100)}%`
              : "—"
          }
          testid="stat-sellthrough"
        />
      </div>
    );
  }

  // Buyer / admin
  return (
    <div data-testid="buyer-analytics" className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4">
      <Card label="Acquired" value={data.orders_paid} accent testid="stat-paid" />
      <Card label="Pending" value={data.orders_pending} testid="stat-pending" />
      <Card label="Total spent" value={fmt$(data.total_spent_usd)} testid="stat-spent" />
      <Card label="Auctions bid on" value={data.auctions_bid_on} testid="stat-auctions" />
    </div>
  );
};

export default AnalyticsCards;
